import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4104c0c8")

_pushScopeId("data-v-4104c0c8")
const _hoisted_1 = { class: "main-wrapper flex flex--v flex--valign-c flex--gap-60" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Hero = _resolveComponent("Hero")
  const _component_FindCompany = _resolveComponent("FindCompany")
  const _component_CompaniesList = _resolveComponent("CompaniesList")
  const _component_PaginationNew = _resolveComponent("PaginationNew")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.companies.data === false)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_Hero, {
            onClickFind: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToJobfuchs()))
          }),
          _createVNode(_component_FindCompany, {
            ref: "startOfJobfuchs",
            "searching-process": _ctx.searchingProcess,
            "economic-sectors": _ctx.economicSectors,
            "selected-economic-sectors": _ctx.sectors,
            "qualification-groups": _ctx.qualificationGroups,
            "qualification-input": _ctx.qualificationInput,
            onEconomicSectorValueChanged: _ctx.handleSectorValueChanged,
            onQualificationValueChanged: _ctx.handleQualificationValueChangedEvent,
            onClickFindCompany: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search()))
          }, null, 8, ["searching-process", "economic-sectors", "selected-economic-sectors", "qualification-groups", "qualification-input", "onEconomicSectorValueChanged", "onQualificationValueChanged"])
        ], 64))
      : (_openBlock(), _createBlock(_component_CompaniesList, {
          key: 1,
          "qualification-input": _ctx.qualificationInput,
          "qualification-groups": _ctx.qualificationGroups,
          companies: _ctx.companies.data,
          "no-companies": _ctx.noCompanies,
          "detail-view-company-id": _ctx.detailViewCompanyId,
          onClickBackToSearch: _ctx.resetSearch,
          onChangeDetailViewCompanyId: _ctx.changeDetailViewCompanyId
        }, null, 8, ["qualification-input", "qualification-groups", "companies", "no-companies", "detail-view-company-id", "onClickBackToSearch", "onChangeDetailViewCompanyId"])),
    (_ctx.companies.data !== false && _ctx.companies.last_page > 1 && !_ctx.detailViewCompanyId)
      ? (_openBlock(), _createBlock(_component_PaginationNew, {
          key: 2,
          "pagination-data": _ctx.companies,
          class: "pagination-new",
          onPaginate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.search($event, true)))
        }, null, 8, ["pagination-data"]))
      : _createCommentVNode("", true)
  ]))
})